import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '@share/utils';
import { axiosInstanceB2B } from '@share/utils';
import { Urls } from '@share/constants';

interface ICurrencyConversionResponse {
  fromCurrency: string;
  toCurrency: string;
  amount: number;
  conversionRate: number;
  convertedValue: number;
  asOf: string;       
  provider: string;
}

interface ICurrencyCalcState {
  loading: boolean;
  result: ICurrencyConversionResponse | null;
}

const initialState: ICurrencyCalcState = {
  loading: false,
  result: null,
};

const currencyCalcSlice = createSlice({
  name: 'currencyCalc',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setResult(state, action: PayloadAction<ICurrencyConversionResponse | null>) {
      state.result = action.payload;
    },
  },
});

export const currencyCalcActions = currencyCalcSlice.actions;
export const currencyCalcReducer = currencyCalcSlice.reducer;


export const convertCurrency = (
  payload: { from: string; to: string; amount: number },
  sucessCallBack: (res: { convertedValue: number; conversionRate: number }) => void
): AppThunk => {
  return async (dispatch) => {
    try {
      dispatch(currencyCalcSlice.actions.setLoading(true));
      const { data } = await axiosInstanceB2B.post(Urls.CURRENCY_CONVERT, payload);
      dispatch(currencyCalcSlice.actions.setLoading(false));
      dispatch(currencyCalcSlice.actions.setResult(data));
      sucessCallBack({ convertedValue: data.convertedValue, conversionRate: data.conversionRate });
    } catch (error) {
      dispatch(currencyCalcSlice.actions.setLoading(false));
    }
  };
};
